import { css } from 'styled-components';

export default css`
  background-color: #177ddc;
  border: 3px solid #177ddc;
  border-radius: 4px;
  margin-top: 15px;

  .button-section {
    background-color: #177ddc;
    transition: height 0.2s;
    overflow: hidden;
    height: 31px;
    &:not(.visible) {
      height: 0;
    }
    button {
      background-color: #177ddc;
      border: 0;
      margin: 2px;
      cursor: pointer;
      letter-spacing: 2px;
      width: 100%;
      font-weight: 400;
      font-size: 1rem;
      &:disabled {
        cursor: not-allowed;
        width: 100%;
        opacity: 0.5;
      }
    }
  }

  .details-section-wrapper {
    background-color: #177ddc;
    overflow: hidden;
    transition: height 0.2s;
    &:not(.visible) {
      height: 0;
    }
    .details-section {
      background-color: #1f1f1f;
      border-radius: 4px;
      padding: 10px;
      height: 100%;
      grid-gap: 20px;
      .note {
        textarea {
          flex: 1;
          width: 100%;
        }
      }
      .void-cancel-actions {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
        grid-gap: 10px;
        position: sticky;
        bottom: 0;
      }
    }

    .flex-container {
      display: flex;
      justify-content: center;
      margin-top: 10px;
    }
  }
`;
